import { styled } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const TrendTooltip = styled(Flex)`
    background-color: ${colorsPalettes.carbon[0]};
    align-items: center;
    gap: 8px;
    box-sizing: border-box;
    padding: 16px;
    box-shadow:
        0 0 8px 0 rgba(0, 0, 0, 0.12),
        0 8px 8px 0 rgba(0, 0, 0, 0.24);
    ${setFontVariant("body2", colorsPalettes.carbon[500])}
`;
